import { render } from "./ResetInvite.vue?vue&type=template&id=72efa085"
import script from "./ResetInvite.vue?vue&type=script&lang=js"
export * from "./ResetInvite.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__